import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { i18n } from '../i18n/index'
// 创建axios实例
const service = axios.create({
  baseURL: econfig.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 200) {
      if(res.message){
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }else{
        Message({
          message: i18n.tc('h.info.guoqi'),
          type: 'error',
          duration: 3 * 1000
        })
      }


      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm(i18n.tc('h.info.outtitle'), i18n.tc('h.info.outok'), {
          confirmButtonText: i18n.tc('h.info.chongxingdenglu'),
          cancelButtonText: i18n.tc('h.info.cancel'),
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js